import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ClientMarquee from "@/components/ClientMarquee";
import Services from "@/components/Services";
import Team from "@/components/Team";
import CaseStudies from "@/components/CaseStudies";
import Plans from "@/components/Plans";
import FundingCalculator from "@/components/FundingCalculator";
import QueryForm from "@/components/QueryForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
}

function App() {
  const [selectedPlan, setSelectedPlan] = useState("Undecided");
  const [planPulse, setPlanPulse] = useState(0);

  useEffect(() => {
    document.title = "Impact Sutra — From Intent to Impact";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollToForm = useCallback((plan) => {
    if (plan) {
      setSelectedPlan(plan);
      setPlanPulse((p) => p + 1);
    }
    scrollToSection("query-callback");
  }, []);

  return (
    <div className="App bg-[#FBFBF9] text-slate-800">
      <Toaster position="top-center" richColors />
      <Navbar onRequestCallback={() => scrollToForm()} />
      <main>
        <Hero onRequestCall={() => scrollToForm()} />
        <EditorialMarquee />
        <ClientMarquee />
        <Services />
        <Team />
        <CaseStudies />
        <Plans onSelectPlan={(plan) => scrollToForm(plan)} />
        <FundingCalculator onApply={(plan) => scrollToForm(plan)} />
        <QueryForm selectedPlan={selectedPlan} onPlanChange={setSelectedPlan} planPulse={planPulse} />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
